// TO DO: Update to use AuthSlice
import React, { createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "../redux/store";
import { RootState } from "../redux/store";
import { login, logout, checkAuthentication } from "../redux/authSlice";
import { UserPermissionDetail } from "@/shared/models/UserList";

import { Pages } from "../shared/Constants";
interface AuthContextType {
  isAuthenticated: boolean;
  isAuthLoading: boolean;
  userRoles: string[];
  userPermission: UserPermissionDetail[];
  userDomain: string;
  login: () => void;
  logout: () => void;
  userName: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, isAuthLoading, userRoles, userPermission, userDomain, userName, isClientProfileSet } = useSelector<RootState, ReturnType<(state: RootState) => RootState['auth']>>((state) => state.auth);

  useEffect(() => {
    console.log("Running Silent Login Check...");
    dispatch(checkAuthentication());
  }, [dispatch]);

  // Conditional navigation after successful login based on client profile status
  useEffect(() => {
    if (isAuthenticated && window.location.pathname === "/") {
      if (!isClientProfileSet) {
        navigate(`/${Pages.clientProfile}`, { replace: true });
      }
    }
  }, [isAuthenticated, isClientProfileSet, navigate]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isAuthLoading,
        userRoles,
        userPermission,
        userDomain,
        login: () => dispatch(login()).catch((err) => console.error(" Login failed", err)),
        logout: () => dispatch(logout()).catch((err) => console.error(" Logout failed", err)),
        userName,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};
